import DisclaimerBanner from './DisclaimerBanner';
import DisclaimerSection from './DisclaimerSection';

function Disclaimer() {
  return (
    <div>
      <DisclaimerBanner />
      <DisclaimerSection />
    </div>
  );
}

export default Disclaimer;